import { map } from "lodash";

export const getters = {
  project: (state) => {
    const fileHeader = {
      id: state.projectProperties.fileHeaderId,
      companyName: state.projectProperties.author.companyName,
      companyUrl: state.projectProperties.author.companyUrl,
      productName: state.projectProperties.project.productName,
      productVersion: state.projectProperties.project.productVersion,
      productRelease: state.projectProperties.project.productRelease,
      contentDescription:
        state.projectProperties.miscellaneous.contentDescription,
    };

    const contentHeader = {
      id: state.projectProperties.contentHeaderId,
      pageSize: state.projectProperties.graphics.pageSize,
      fbd: state.projectProperties.graphics.fbd,
      ld: state.projectProperties.graphics.ld,
      sfc: state.projectProperties.graphics.sfc,
      name: state.projectProperties.project.projectName,
      version: state.projectProperties.project.projectVersion,
      organization: state.projectProperties.author.organization,
      author: state.projectProperties.author.authorName,
      language: state.projectProperties.miscellaneous.language,
    };

    const configurations = [state.configuration];

    const dataTypes = state.dataTypes;

    const pous = map(state.pous, (pou) => ({
      ...pou,
      bodies: [pou.body],
      variables: pou.variables,
    }));

    const project = {
      fileHeader,
      contentHeader,
      configurations,
      dataTypes,
      pous,
    };

    return project;
  },
};
